<template>
  <section class="services-area ptb-70">
    <div class="container-fluid p-0">
      <div class="overview-box">
        <div class="overview-content">
          <div class="content left-content">
            <h2>Adept</h2>
    
            <p>
              This is a cross functional customizable payment solution. it provides public and private billing agencies and organisation such as Electricity DisCos, Schools,Hospitals etc. with cashless and cardless payment alternatives for their customers
            </p>
            <ul class="services-list">
              <li>
                <span>
                  <i class="flaticon-check-mark"></i>Cashless/Cardless payment solution
                </span>
              </li>

              <li>
                <span>
                  <i class="flaticon-check-mark"></i>Fast and reliable payment solution for customers
                </span>
              </li>
              
            </ul>
          </div>
        </div>
        <div class="overview-image">
          <div class="image">
            <img src="assets/img/adept.jpeg" alt="image" />
            
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>